import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
const headCells = [

	{ id: 'pr_title', numeric: false, label: 'Title' },
	{ id: 'pr_code', numeric: false, label: 'Code' },

	{ id: 'pr_startdate', numeric: false, label: 'Start Date' },
	{ id: 'pr_enddate', numeric: false, label: 'End Date' },
	
 
 
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});





export default class promotion extends Component {
	
    constructor(props) {
    super(props);
   
     this.state = {redirect: false,editredirect: false,prid:'',
     promodata:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'pr_id',oftitle:'',pr_id:'',pr_enddate:'',pr_startdate:'',pr_type:'',type:'',pr_description:'',
	          
      }
	  
	}
	  

componentWillMount() {
document.title = "AthaYog Living - Promotions";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
  this.apicall(this.state.page,this.state.rowsPerPage);
 
} 

	




handleChangePage = (event, newPage) => {  
   

    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); });
  };  
  
   handleChangeRowsPerPage = event => {  
  
 
let pageval = event.target.value;
    
    this.setState({  
      page: 0,
      rowsPerPage:this.state.rowsPerPage,
	  prevpage:-1
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 



apicall(page,rowsPerPage){
	
 axios.get(Serverurl+'ajaxpromotion.php?action=getall&pr_type='+this.state.pr_type+'&pr_title='+this.state.oftitle+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  promodata:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
		
			
	  
	 
	 
     }
	 else{
		   this.setState({promodata:[],totaldata:0});
	 }
 
    });
}


 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
  
  
  
  
   PromotionDelete(prid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();

     formData.append('action','delete')
	 
	 formData.append('pr_id',prid)
	 
		   
formData.append('userid',localStorage.getItem("AYLuserid"))	
	
	 axios.post(Serverurl+"ajaxpromotion.php", formData, {
        }).then(res => {
    
             this.apicall(this.state.page,this.state.rowsPerPage); 
 

  
    
            });
 }
      }
	  
	handleClickSearch=()=>{  
  
this.setState({  
      page: 0,
      rowsPerPage:this.state.rowsPerPage,
	  prevpage:-1
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	 

  }  

  myChangeHandler = (event) => {

  let nam = event.target.name;
  let val = event.target.value;
    
 
  this.setState({[nam]: val});
  
  
} 


render() {
	
	
	if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 

 <React.Fragment>
  

<div className="boxheading">			  
<h2>Coupon Code</h2>

</div>
<div className="addandbacbtn"><a href='/Addpromotion' >New</a></div>
<div className="clear"></div>

   <div className="searchmaster"> 
<ul>
	
<li>
 
 <p>Title</p>
		<p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.oftitle}
            id="name"
             inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
            name="oftitle" onChange={this.myChangeHandler}
          /></p>
		
		</li>
			<li>
	 <p>Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="pr_type"
		   value={this.state.pr_type} inputProps={{tabIndex: "2"}}
		  name="pr_type"
		
        >
	
	<option value="">Select Type</option>
      
		   <option value={1}>Rupees</option>
          <option value={2}>Percentage</option>
 <option value={3}>Days</option>


        </Select>

		</FormControl>
		</p>
	</li>
<li>

 <p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p></li>
 
 
 </ul>
</div>


    

<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.promodata.length}
            />
                      <TableBody>
                     {stableSort(this.state.promodata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.pr_title}</TableCell>
<TableCell>{item.pr_code}</TableCell>

<TableCell>{item.startdate}</TableCell>
<TableCell>{item.enddate}</TableCell>


<TableCell align="left">


<a href={'/Addpromotion?Prid='+item.pr_id}>
<Button variant="text"  className="frmSecondarybtn"   startIcon={<EditIcon />}>
Edit
</Button></a>


&nbsp;&nbsp;
 
<Button variant="contained"  className="frmthirdbtn"  onClick={()=>{this.PromotionDelete(item.pr_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button> 


 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20, 30,40,50,60,70,80,90,100]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      /> 
  </Paper>
    



 

 </React.Fragment>
 



);


		}
	
}


